module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0746c_banner_800x600.9f2e1e0b.png";